import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description Gift icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { Gift } from '@sravni/design-system-icons'
 *
 * <Gift />
 * ```
 */
var Gift = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "Gift", viewBox: "0 0 21 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { clipRule: "evenodd", d: "M17.436 6.667H4.103a.834.834 0 0 0-.833.833v1.666c0 .46.373.834.833.834h13.333c.46 0 .834-.373.834-.834V7.5a.834.834 0 0 0-.834-.833Z", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M10.77 17.5V6.666M13.85 5.51c-.9.935-2.313 1.157-2.998 1.157M10.852 6.667s-.411-2.597.601-3.65M13.849 5.51a1.814 1.814 0 0 0 0-2.493 1.648 1.648 0 0 0-2.396 0M7.69 5.51c.898.935 2.312 1.157 2.997 1.157", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M10.687 6.667s.411-2.597-.601-3.65M7.69 5.51a1.814 1.814 0 0 1 0-2.493 1.648 1.648 0 0 1 2.395 0M16.602 10v6.667c0 .46-.373.833-.833.833h-10a.834.834 0 0 1-.833-.833V10", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

export { Gift };
//# sourceMappingURL=Gift.js.map
